import Grid from '@mui/material/Grid2'
import { Button, Box, Typography, Divider } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Stage, Layer, Text, Circle, Group, Rect, Image, Label, Tag } from 'react-konva'
import useImage from 'use-image'

import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'

import Api from '../../../Api/Api'

import { TreeSelect } from 'antd'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import secureLocalStorage from 'react-secure-storage'

import save_icon from '../../../asset/save_icon.png'

const Title = (props) => {
  // console.log('render')
  return <Typography>{props.title}</Typography>
}

var SCENE_BASE_WIDTH = 1000
var SCENE_BASE_HEIGHT = SCENE_BASE_WIDTH / 2

const styles1 = {
  Typography1: {
    color: '#ffffff',
    fontFamily: 'Noto Sans KR',
    fontSize: '20px',
    fontWeight: 700,
    lineHeight: '28.96px',
    textAlign: 'left',
    textUnderlinePosition: 'from-font',
    textDecorationSkipInk: 'none',
  },
  Typography2: {
    color: '#ffffff',
    fontFamily: 'Montserrat',
    fontSize: '10px',
    fontWeight: 600,
    textAlign: 'left',
    textUnderlinePosition: 'from-font',
    textDecorationSkipInk: 'none',
  },

  Box1: {
    height: 42,
    display: 'flex',
    justifyContent: 'center',
    alignItem: 'center',
    width: '100%',
    background:
      'linear-gradient(180deg, rgba(217, 217, 217, 0.2) 0%, rgba(0, 0, 0, 0.04) 100%),linear-gradient(0deg, rgba(0, 0, 0, 0.14), rgba(0, 0, 0, 0.14))',
  },
  grid1: {
    backdropFilter: 'blur(53px)',
    boxShadow: '-8px 4px 5px 0px #0000003d',
    borderRadius: '10px',
    background:
      'linear-gradient(0deg, rgba(0, 0, 0, 0.14), rgba(0, 0, 0, 0.14)),linear-gradient(321.23deg, rgba(191, 191, 191, 0.062) 15.98%, rgba(0, 0, 0, 0) 36.28%)',
    border: '1px solid #afafaf',
    borderImageSource:
      'linear-gradient(166.93deg, #afafaf 3.24%, rgba(96, 96, 96, 0) 96.43%),linear-gradient(317.92deg, rgba(255, 255, 255, 0.6) 1.48%, rgba(0, 0, 0, 0) 37.95%)',
  },
  Select1: {
    '& label': {
      color: '#e4e4e7',
    },
    '.MuiOutlinedInput-notchedOutline': {
      borderColor: '#afafaf',
      opacity: 0.8,
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: '#afafaf',
      borderWidth: '1px',
      opacity: 0.8,
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#afafaf',
      borderWidth: '1px',
    },
    '& .MuiSvgIcon-root': {
      color: '#ffffff',
    },
    '& .MuiInputBase-input': {
      color: '#ffffff',
    },
    '&:hover .MuiInputBase-input': {
      borderColor: '#afafaf',
      borderWidth: '1px',
      opacity: 0.8,
    },
    '&.Mui-focused .MuiInputBase-input': {
      borderColor: '#afafaf',
      borderWidth: '1px',
    },

    color: '#ffffff',
    backdropFilter: 'blur(53px)',
    boxShadow: '-8px 4px 5px 0px #0000003d',
    borderRadius: '10px',
    background: '#171821',
    // border: '1px solid #afafaf',
    // borderImageSource:
    //   'linear-gradient(166.93deg, #afafaf 3.24%, rgba(96, 96, 96, 0) 96.43%),linear-gradient(317.92deg, rgba(255, 255, 255, 0.6) 1.48%, rgba(0, 0, 0, 0) 37.95%)',
  },
}

export default function SceneLocation() {
  const loginId = secureLocalStorage.getItem('loginId')
  const [OrgData, setOrgData] = useState([])
  const [inputOrgid, setInputOrgid] = useState('1110')
  const [locationList, setLocationList] = useState([])
  const [deviceLocation, setDeviceLocation] = React.useState('62d26fb0')
  const [locationInfo, setLocationInfo] = React.useState('')
  const [deviceList, setDeviceList] = useState([])

  const [resultDeviceList, setResultDeviceList] = useState([])

  const [size, setSize] = React.useState({
    width: SCENE_BASE_WIDTH,
    height: SCENE_BASE_HEIGHT,
  })

  const [localPos, setPos] = React.useState({ x: 0, y: 0 })
  const layerRef = React.useRef()
  const boxRef = React.useRef()

  const handledeviceLocation = (event) => {
    console.log('handledeviceLocation:', event.target.value)
    setDeviceLocation(event.target.value)
  }

  //초기화면 진입시 최상단 스크롤
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  useEffect(() => {
    // getLocationListFirst()
    // getLocationInfo()
    getDeviceListloid()
    Org()
  }, [])

  useEffect(() => {
    getLocationList()
  }, [inputOrgid])

  useEffect(() => {
    getLocationInfo()
    console.log('deviceLocation:', deviceLocation)
    if (deviceLocation !== null && deviceLocation !== '') {
      getDeviceListloid()
    }
  }, [deviceLocation])

  useEffect(() => {
    if (boxRef.current?.offsetHeight && boxRef.current?.offsetWidth) {
      setSize({
        width: boxRef.current.offsetWidth,
        height: boxRef.current.offsetWidth / 2,
      })
    }
  }, [])

  React.useEffect(() => {
    const checkSize = () => {
      const colEl = document.querySelector('.konva_box')
      setSize({
        width: colEl.offsetWidth,
        height: colEl.offsetWidth / 2,
      })
    }

    window.addEventListener('resize', checkSize)
    return () => window.removeEventListener('resize', checkSize)
  }, [])

  // do your calculations for stage properties
  const scale1 = size.width / SCENE_BASE_WIDTH

  const LionImage = (param) => {
    // console.log("LionImage param:",param.param)
    const [image] = useImage(param.param)
    return <Image cornerRadius={10} image={image} width={SCENE_BASE_WIDTH} height={SCENE_BASE_HEIGHT} />
  }

  //부서 리스트
  const Org = async () => {
    try {
      const response = await Api.get('/api/v1/orgn')
      // const response = await Api.get('/api/v1/orgn', {
      //   withCredentials: true,
      // })
      if (response.status === 200) {
        setOrgData(response.data)
      }
      // console.log('response.data', response.data)
    } catch (e) {
      console.log('Org exception', e)
    }
  }

  //시설 리스트
  const getLocationList = async () => {
    setLocationList([])
    // setDeviceLocation('')
    setLocationInfo('')
    setDeviceList([])
    setResultDeviceList([])
    // const headers = {
    //   istree: true,
    // }
    try {
      // const response = await Api.get(`/api/v1/loca/?orgz_id=${inputOrgid}`, { headers: headers })
      // const response = await Api.get(`/api/v1/loca/?orgz_id=${inputOrgid}`)
      const response = await Api.get(`/api/v1/loca/get_loca/without_bf?orgid=${inputOrgid}`)
      if (response.status === 200) {
        console.log('getLocationList:', response.data)
        setLocationList(response.data)
      }
      // console.log('response.data Users', response.data)
    } catch (e) {
      console.log('getLocationList exception', e)
    }
  }

  // const getLocationListFirst = async () => {
  //   setLocationList([])
  //   setLocationInfo('')
  //   setDeviceList([])
  //   setResultDeviceList([])
  //   const headers = {
  //     istree: true,
  //   }
  //   try {
  //     const response = await Api.get(`/api/v1/loca/?orgz_id=${inputOrgid}`, { headers: headers })

  //     if (response.status === 200) {
  //       console.log('getLocationList:', response.data)
  //       setLocationList(response.data)
  //     }
  //     // console.log('response.data Users', response.data)
  //   } catch (e) {
  //     console.log('getLocationList exception', e)
  //   }
  // }

  //시설 정보
  const getLocationInfo = async () => {
    try {
      const response = await Api.get(`/api/v1/loca/${deviceLocation}`)

      if (response.status === 200) {
        console.log('getLocationInfo response.data:', response.data)
        const dvloc_data = response.data.dvloc

        if (dvloc_data === null || dvloc_data === '' || dvloc_data === undefined) {
          setResultDeviceList([])
        } else {
          console.log('getLocationInfo JSON.parse(dvloc_data):', JSON.parse(dvloc_data))
          setResultDeviceList(JSON.parse(dvloc_data))
        }
        setLocationInfo(response.data)
      }
    } catch (e) {
      console.log('getLocationInfo exception', e)
    }
  }

  const handleDragStart = (e) => {
    console.log('handleDragStart e:', e)
    const id = e.target.attrs.id
    setResultDeviceList(
      resultDeviceList.map((star) => {
        return {
          ...star,
          isDragging: star.di === id,
        }
      })
    )
  }
  const handleDragEnd = (e) => {
    console.log('handleDragEnd e:', e)
    console.log('End name:', e.target.attrs.id)
    const tempName = e.target.attrs.id
    const xy = getPosion(e)
    setResultDeviceList(
      resultDeviceList.map((star) => {
        return {
          ...star,
          isDragging: false,
          x: star.di === tempName ? parseInt(xy.x) : star.x,
          y: star.di === tempName ? parseInt(xy.y) : star.y,
        }
      })
    )
  }

  function getPosion(e) {
    console.log('name:', e.target.attrs.id)
    var transform = layerRef.current.getAbsoluteTransform().copy()
    // to detect relative position we need to invert transform
    transform.invert()
    // now we find relative point
    const pos = e.target.getStage().getPointerPosition()
    var circlePos = transform.point(pos)
    console.log('getPosion x:y', JSON.stringify(circlePos))
    return circlePos
  }

  /**
   * useState 객체 배열 변경
   * @param {*} param
   * @param {*} x
   * @param {*} y
   */

  function findInList(param) {
    let copyState = [...resultDeviceList]
    console.log('findInList copyState:', copyState)
    const find1 = copyState.findIndex((element, index, array) => {
      return element.di === param.di
    })
    console.log('find1:', find1)
    return find1
  }

  function addresultDeviceList(param) {
    console.log('addresultDeviceList param:', param)
    let copyState = [...resultDeviceList]

    const addObject = {
      di: param.di,
      dname: param.dname,
      dsi: param.dsi,
      x: 155,
      y: 155,
    }

    const Indexvalue = findInList(param)
    if (Indexvalue < 0) {
      copyState.push(addObject)
      setResultDeviceList(copyState)
      console.log('addresultDeviceList copyState:', copyState)
    } else {
      alert('이미 리스트에 추가됨')
    }
  }

  function deleteresultDeviceList(param) {
    let copyState = [...resultDeviceList]
    const Indexvalue = findInList(param)
    if (Indexvalue >= 0) {
      copyState.splice(Indexvalue, 1)
      setResultDeviceList(copyState)
    }
  }

  const getDeviceListloid = async () => {
    console.log(`ckNetDevice=true&orgid=${inputOrgid}&loid=${deviceLocation}`)
    try {
      const response = await Api.get(`api/v1/devices/?ckNetDevice=true&orgid=${inputOrgid}&loid=${deviceLocation}`)
      if (response.status === 200) {
        setDeviceList(response.data)
      }
      console.log('getDeviceListloid response.data1:', response.data)
    } catch (e) {
      console.log('getDeviceListloid exception', e)
    }
  }

  //patchDvloc 좌표변경 수정
  const patchDvloc = async () => {
    const patchObject = {
      dvloc: JSON.stringify(resultDeviceList),
      uid: loginId,
    }
    console.log('patchDvloc patchObject:', patchObject)
    console.log('patchDvloc deviceLocation:', deviceLocation)

    try {
      const response = await Api.patch(`api/v1/loca/${deviceLocation}`, patchObject)
      if (response.status === 200) {
        // setDeviceList(response.data)
        alert('시설 설치 장치 장소가 저장되었습니다.')
        setResultDeviceList(JSON.parse(response.data.dvloc))
        console.log('patchDvloc ok:', response.data)
      }
      console.log('patchDvloc response.data:', response.data)
    } catch (e) {
      console.log('patchDvloc exception', e)
    }
  }

  return (
    <div>
      <Grid container spacing={3}>
        <Grid size={12} sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', marginLeft: 4 }}>
          <TreeSelect
            className="treeSelect"
            suffixIcon={<ArrowDropDownIcon />}
            style={{ marginTop: -22 }}
            value={inputOrgid}
            dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
            treeData={OrgData}
            treeTitleRender={(item) => {
              return <Title title={item.orgn} />
            }}
            fieldNames={{ labal: 'orgid', key: 'orgid', value: 'orgid' }}
            placeholder="부서 선택"
            treeDefaultExpandAll
            onChange={(e) => {
              setDeviceLocation('')
              setInputOrgid(e)
            }}
          />
          <Select
            displayEmpty
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={deviceLocation}
            // label="시설 선택"
            // placeholder="부서 선택"
            onChange={handledeviceLocation}
            sx={[styles1.Select1, { width: 150, marginLeft: 1 }]}
          >
            {locationList.map((item, index) => {
              return (
                <MenuItem key={index} value={item.loid}>
                  {item.lon}
                </MenuItem>
              )
            })}
          </Select>
        </Grid>
        <Divider sx={{ height: 1, width: 1 }}></Divider>
        <Grid size={12} sx={{ marginTop: -5 }}>
          <Grid container spacing={3}>
            <Grid size={7.5}>
              <Grid container sx={{ padding: 5 }}>
                <Grid size={12}>
                  <Grid container>
                    <Grid size={6}>
                      <Typography sx={[styles1.Typography1]}>현장 장비 배치 관리</Typography>
                    </Grid>
                    <Grid size={6} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                      <Button
                        variant="contained"
                        sx={{
                          background: '#454546',
                        }}
                        onClick={() => patchDvloc()}
                      >
                        <img src={save_icon} style={{width:23,height:23,margin:4}}></img>
                        저장하기
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid size={12} sx={[styles1.grid1, { height: 1, marginTop: 2 }]}>
                  <div>
                    <Box
                      className="konva_box"
                      ref={boxRef}
                      sx={[{ width: 1, justifyContent: 'center', alignItems: 'center', justifyItems: 'center' }]}
                    >
                      <Stage
                        width={size.width}
                        height={size.height}
                        scaleX={scale1}
                        scaleY={scale1}
                        // onMouseMove={(e) => {
                        //   var transform = layerRef.current.getAbsoluteTransform().copy()
                        //   // to detect relative position we need to invert transform
                        //   transform.invert()
                        //   // now we find relative point
                        //   const pos = e.target.getStage().getPointerPosition()
                        //   var circlePos = transform.point(pos)
                        //   setPos(circlePos)
                        // }}
                      >
                        <Layer ref={layerRef}>
                          {/* <Circle radius={10} fill="green" x={localPos.x} y={localPos.y} /> */}
                          <LionImage param={locationInfo.bf} />
                          {resultDeviceList !== null &&
                          resultDeviceList !== undefined &&
                          resultDeviceList !== '' &&
                          resultDeviceList
                            ? resultDeviceList.map((star, index) => {
                                if (star.hasOwnProperty('x') === true && star.hasOwnProperty('y') === true) {
                                  return (
                                    <Group
                                      onDragStart={handleDragStart}
                                      onDragEnd={handleDragEnd}
                                      draggable
                                      key={star.dname}
                                      id={star.di}
                                      x={star.x}
                                      y={star.y}
                                    >
                                      <Circle
                                        radius={20}
                                        fill="#ffff00"
                                        opacity={0.8}
                                        // onClick={deleteThis}
                                        // rotation={star.rotation}
                                        shadowColor="black"
                                        shadowBlur={10}
                                        shadowOpacity={0.6}
                                        // shadowOffsetX={star.isDragging ? 10 : 5}
                                        // shadowOffsetY={star.isDragging ? 10 : 5}
                                        scaleX={star.isDragging ? 1.2 : 1}
                                        scaleY={star.isDragging ? 1.2 : 1}
                                        onDblClick={() => console.log(star)}
                                      />
                                      <Label x={10} y={-25}>
                                        <Tag
                                          fill="black"
                                          pointerDirection="down"
                                          pointerWidth={10}
                                          pointerHeight={10}
                                          lineJoin="round"
                                          shadowColor="black"
                                          shadowBlur={10}
                                          shadowOffsetX={10}
                                          shadowOffsetY={10}
                                          shadowOpacity={0.5}
                                        ></Tag>
                                        <Text
                                          text={`${star.dname}`}
                                          fontFamily="Calibri"
                                          fontSize={18}
                                          padding={5}
                                          fill="white"
                                        />
                                      </Label>
                                      <Text
                                        text={`${star.dname}`}
                                        fill="#ff0000"
                                        wrap="char"
                                        align="center"
                                        x={-30}
                                        y={25}
                                      />
                                      <Text
                                        text={`삭제`}
                                        fill="#12eefe"
                                        wrap="char"
                                        align="center"
                                        x={-30}
                                        y={-35}
                                        onClick={() => deleteresultDeviceList(star)}
                                      />
                                    </Group>
                                  )
                                }
                              })
                            : ''}
                        </Layer>
                      </Stage>
                    </Box>
                  </div>
                </Grid>
              </Grid>
            </Grid>
            <Grid size={4.5} sx={{ padding: 4 }}>
              <Grid container spacing={2}>
                <Grid size={12}>
                  <Box sx={[styles1.Box1, { marginTop: 1 }]}>
                    <Typography
                      sx={[styles1.Typography1, { display: 'flex', justifyContent: 'center', alignItems: 'center' }]}
                    >
                      현장 장비
                    </Typography>
                  </Box>
                  <Grid container sx={[styles1.grid1, { marginTop: 1.2 }]}>
                    <Grid size={6}>
                      {deviceList !== null && deviceList !== undefined && deviceList !== '' && deviceList
                        ? deviceList.map((item, index) => {
                            if (item.dsi === 'Gateway') {
                              return (
                                <List key={item.di} sx={{ width: '100%', maxWidth: 360 }}>
                                  <ListItem onDoubleClick={() => addresultDeviceList(item)}>
                                    <Box
                                      sx={{
                                        height: 19,
                                        width: 19,
                                        borderRadius: '50%',
                                        background: '#182AEF',
                                        marginRight: 1,
                                      }}
                                    ></Box>
                                    <Typography
                                      sx={[styles1.Typography2, { fontSize: 12.5 }]}
                                    >{`${item.dname}`}</Typography>
                                  </ListItem>
                                </List>
                              )
                            }
                          })
                        : ''}
                    </Grid>
                    <Grid size={6}>
                      {deviceList !== null && deviceList !== undefined && deviceList !== '' && deviceList
                        ? deviceList.map((item, index) => {
                            if (item.dsi === 'Repeater') {
                              return (
                                <List key={item.di} sx={{ width: '100%', maxWidth: 360 }}>
                                  <ListItem onDoubleClick={() => addresultDeviceList(item)}>
                                    <Box
                                      sx={{
                                        height: 19,
                                        width: 19,
                                        borderRadius: '50%',
                                        background: '#FF8A04',
                                        marginRight: 1,
                                      }}
                                    ></Box>
                                    <Typography
                                      sx={[styles1.Typography2, { fontSize: 12.5 }]}
                                    >{`${item.dname}`}</Typography>
                                  </ListItem>
                                </List>
                              )
                            }
                          })
                        : ''}
                    </Grid>
                  </Grid>
                </Grid>
                <Divider sx={{ width: '100%', height: 3 }} />
                <Grid size={12}>
                  {/* mark */}
                  <Box sx={styles1.Box1}>
                    <Typography
                      sx={[styles1.Typography1, { display: 'flex', justifyContent: 'center', alignItems: 'center' }]}
                    >
                      시설 설치 장치
                    </Typography>
                  </Box>
                  <Grid container sx={[styles1.grid1, { marginTop: 1 }]}>
                    <Grid size={6}>
                      {resultDeviceList !== null && resultDeviceList !== undefined && resultDeviceList !== ''
                        ? resultDeviceList.map((item, index) => {
                            if (item.dsi === 'Gateway') {
                              return (
                                <List key={item.di} sx={{ width: '100%', maxWidth: 360 }}>
                                  <ListItem onDoubleClick={() => deleteresultDeviceList(item)}>
                                    <Box
                                      sx={{
                                        height: 19,
                                        width: 19,
                                        borderRadius: '50%',
                                        background: '#182AEF',
                                        marginRight: 1,
                                      }}
                                    ></Box>
                                    <Typography
                                      sx={[styles1.Typography2, { fontSize: 12.5 }]}
                                    >{`${item.dname}`}</Typography>
                                  </ListItem>
                                </List>
                              )
                            }
                          })
                        : ''}
                    </Grid>
                    <Grid size={6}>
                      {resultDeviceList !== null && resultDeviceList !== undefined && resultDeviceList !== ''
                        ? resultDeviceList.map((item, index) => {
                            if (item.dsi === 'Repeater') {
                              return (
                                <List key={item.di} sx={{ width: '100%', maxWidth: 360 }}>
                                  <ListItem onDoubleClick={() => deleteresultDeviceList(item)}>
                                    <Box
                                      sx={{
                                        height: 19,
                                        width: 19,
                                        borderRadius: '50%',
                                        background: '#FF8A04',
                                        marginRight: 1,
                                      }}
                                    ></Box>
                                    <Typography
                                      sx={[styles1.Typography2, { fontSize: 12.5 }]}
                                    >{`${item.dname}`}</Typography>
                                  </ListItem>
                                </List>
                              )
                            }
                          })
                        : ''}
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Divider sx={{ height: 1, width: 1 }}></Divider>
      </Grid>
    </div>
  )
}
